(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wg-mobile-backup-20261025-0823"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const initialize=(root)=>{
  if(root.dataset.orbitReady==='true')return;
  root.dataset.orbitReady='true';
  const slides=[...root.querySelectorAll('[data-slide]')];
  const dots=[...root.querySelectorAll('[data-go]')];
  const track=root.querySelector('.wgmm__track');
  const pauseButton=root.querySelector('.wgmm__pause');
  const designTitle=root.querySelector('[data-design-title]');
  if(slides.length<2||!track)return;
  const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  const total=slides.length;
  const step=Math.PI*2/total;
  const interval=Math.max(1000,Number(root.dataset.interval)||1000);
  let angle=0,paused=reduced,focusWithin=false,hovering=false;
  let announced=-1,revealPaused=null;
  const setting=(name,fallback)=>{
   const value=parseFloat(getComputedStyle(root).getPropertyValue(name));
   return Number.isFinite(value)?value:fallback;
  };
  const normalize=value=>((value+Math.PI)%(Math.PI*2)+Math.PI*2)%(Math.PI*2)-Math.PI;
  const paint=()=>{
   const width=track.clientWidth||root.clientWidth;
   const height=track.clientHeight||root.clientHeight;
   const radiusX=(width<750?Math.min(width*.35,132):Math.min(width*.40,286))*.78;
   const centerY=height*.78-(width<750?12:32);
   const radiusY=width<750?height*.08:height*.14;
   const overall=setting('--model-scale',.82)*setting('--carousel-scale',1);
   const frontScale=setting('--active-scale',1.12);
   const rearScale=setting('--side-scale',.68);
   const frontAnchor=centerY+radiusY+height*.10;
   const tallest=Math.max(...slides.map(slide=>slide.offsetHeight));
   const fit=Math.min(1,Math.max(0,frontAnchor-16)/(tallest*overall*frontScale*1.1));
   const fittedOverall=overall*fit;
   const poolY=frontAnchor-tallest*fittedOverall*frontScale*1.1*.055;
   const poolHeight=width<750?Math.min(70,Math.max(48,width*.10)):Math.min(116,Math.max(72,width*.09));
   const carousel=root.querySelector('.wgmm__carousel');
   carousel.style.setProperty('--pool-y',poolY.toFixed(2)+'px');
   // Keep the approved scale; translate the complete stage to a 96 CSS-pixel header gap.
   const imageBounds=[
    ['wg-kindness-clean-edges-v1.png',20/1099,1],
    ['wg-unequal_match-clean-edges-v1.png',21/1374,1],
    ['wg-erratically-transparent-no-haze-v3.png',58/1536,1425/1536],
    ['wg-assume-transparent-no-haze-v3.png',48/1536,1],
    ['wg-twisted-carousel-final.png',65/1536,1422/1536],
    ['wrong-guy-carousel-blond-white-male-gold-v2.png',29/1536,1414/1536]
   ];
   const frontHeights=slides.map(slide=>{
    const image=slide.querySelector('img:last-child');
    const imageHeight=image&&image.naturalWidth?Math.min(slide.clientHeight,slide.clientWidth*image.naturalHeight/image.naturalWidth):slide.clientHeight;
    const fitScale=parseFloat(getComputedStyle(slide).getPropertyValue('--fit-scale'))||1;
    const bounds=imageBounds.find(entry=>image&&image.src.includes(entry[0]))||['',0,1];
    const bottomSpace=slide.clientHeight-imageHeight+imageHeight*(1-bounds[2]);
    slide.style.setProperty('--leg-offset',(bottomSpace*fitScale).toFixed(2)+'px');
    return imageHeight*(bounds[2]-bounds[1])*fitScale*fittedOverall*frontScale*1.1;
   });
   const maxFrontHeight=Math.max(...frontHeights);
   const femaleHeight=frontHeights[0]||maxFrontHeight;
   const lowerBanner=root.querySelector('.wgmm__ticker');
   const bannerBottom=lowerBanner?lowerBanner.offsetTop+lowerBanner.offsetHeight:100;
   const frontBaseline=poolY+poolHeight*.63;
   const previousFemaleGap=96+maxFrontHeight-femaleHeight;
   const shift=bannerBottom+96-(carousel.offsetTop+frontBaseline-maxFrontHeight)-previousFemaleGap/3;
   carousel.style.setProperty('--stage-shift',shift.toFixed(2)+'px');
   const carouselTop=carousel.offsetTop+shift;
   root.style.setProperty('--caption-y',(carouselTop+poolY+92).toFixed(2)+'px');
   let nearest=0,nearestDistance=Infinity,nearestFrontEase=0;
   slides.forEach((slide,index)=>{
    const theta=normalize(index*step-angle);
    const cosine=Math.cos(theta);
    const depth=(cosine+1)/2;
    const scale=rearScale+(frontScale-rearScale)*Math.pow(depth,1.8);
    const x=Math.sin(theta)*radiusX;
    const y=poolY+poolHeight*(.45+.18*cosine);
    const front=Math.abs(theta)<step/2;
    const frontDistance=Math.max(0,1-Math.abs(theta)/(step/2));
    const frontEase=frontDistance*frontDistance*(3-2*frontDistance);
    if(Math.abs(theta)<nearestDistance){nearest=index;nearestDistance=Math.abs(theta);nearestFrontEase=frontEase}
    slide.style.left='calc(50% + '+x.toFixed(2)+'px)';
    slide.style.top=y.toFixed(2)+'px';
    slide.style.transform='translate(-50%,-100%) scale('+(fittedOverall*scale*(1+.1*frontEase)).toFixed(3)+')';
    slide.style.opacity=(.56+depth*.44).toFixed(2);
    slide.style.zIndex=String(Math.round(1+depth*1000));
    slide.classList.toggle('is-front',front);
    slide.setAttribute('aria-current',String(front));
    slide.tabIndex=front?0:-1;
   });
   dots.forEach((dot,index)=>dot.setAttribute('aria-pressed',String(index===nearest)));
   if(designTitle){designTitle.style.opacity=nearestFrontEase.toFixed(2);const settle=nearestFrontEase;const scale=.97+.03*settle+.018*Math.sin(Math.PI*settle);designTitle.style.transform='translateY('+((1-settle)*5).toFixed(1)+'px) scale('+scale.toFixed(3)+')';}
   if(designTitle&&announced!==nearest){
    announced=nearest;
    const lines=(slides[nearest].dataset.designName||'').split('|').filter(Boolean);
    designTitle.replaceChildren(document.createTextNode('“'),...lines.map(line=>{const span=document.createElement('span');span.textContent=line.trim();return span}),document.createTextNode('”'));
   }
  };
  let timer=null;
  const turnDuration=2000;
  let frame=null,turnStart=0,fromAngle=0,toAngle=0;
  const stop=()=>{
   if(timer!==null)clearTimeout(timer);
   if(frame!==null)cancelAnimationFrame(frame);
   timer=null;frame=null;turnStart=0;
  };
  const animateTurn=now=>{
   if(paused||focusWithin||hovering||document.hidden){frame=null;turnStart=0;return}
   if(!turnStart)turnStart=now;
   const progress=Math.min(1,(now-turnStart)/turnDuration);
   const eased=progress<.5?4*progress*progress*progress:1-Math.pow(-2*progress+2,3)/2;
   angle=fromAngle+(toAngle-fromAngle)*eased;
   paint();
   if(progress<1){frame=requestAnimationFrame(animateTurn);return}
   angle=toAngle;paint();frame=null;turnStart=0;
   timer=window.setTimeout(advance,interval);
  };
  const advance=()=>{
   if(paused||focusWithin||hovering||document.hidden)return;
   fromAngle=angle;toAngle=angle+step;turnStart=0;
   frame=requestAnimationFrame(animateTurn);
  };
  const start=()=>{stop();if(!paused&&!focusWithin&&!hovering&&!document.hidden)timer=window.setTimeout(advance,interval)};
  const goTo=index=>{angle=index*step;paint();start()};
  const manual=direction=>{angle+=direction*step;paint();start()};
  const updatePauseButton=()=>{
   if(!pauseButton)return;
   pauseButton.textContent=paused?'Play':'Pause';
   pauseButton.setAttribute('aria-label',paused?'Resume automatic rotation':'Pause automatic rotation');
   pauseButton.setAttribute('aria-pressed',String(paused));
  };
  if(pauseButton){
   updatePauseButton();
   pauseButton.addEventListener('click',()=>{
    paused=!paused;
    updatePauseButton();
    if(paused)stop();
    else{focusWithin=false;start()}
   });
  }

  root.querySelector('.wgmm__arrow--prev').addEventListener('click',()=>manual(-1));
  root.querySelector('.wgmm__arrow--next').addEventListener('click',()=>manual(1));
  dots.forEach((dot,index)=>dot.addEventListener('click',()=>goTo(index)));
  slides.forEach((slide,index)=>slide.addEventListener('click',()=>{goTo(index);paused=true;stop()}));
  root.addEventListener('keydown',event=>{if(event.target.closest('a'))return;if(event.key==='ArrowRight'){event.preventDefault();manual(1)}if(event.key==='ArrowLeft'){event.preventDefault();manual(-1)}});
  let touchX=null;
  track.addEventListener('touchstart',event=>{touchX=event.changedTouches[0].clientX},{passive:true});
  track.addEventListener('touchend',event=>{if(touchX===null)return;const dx=event.changedTouches[0].clientX-touchX;if(Math.abs(dx)>40)manual(dx<0?1:-1);touchX=null},{passive:true});
  root.addEventListener('focusin',event=>{if(event.target.closest('.wgmm__pause'))return;focusWithin=true;stop()});
  root.addEventListener('focusout',()=>{window.setTimeout(()=>{const active=document.activeElement;focusWithin=root.contains(active)&&!(active&&active.closest('.wgmm__pause'));start()},0)});
  root.addEventListener('mouseenter',()=>{if(matchMedia('(hover:hover)').matches){hovering=true;stop()}});
  root.addEventListener('mouseleave',()=>{hovering=false;start()});
  root.addEventListener('wg:transition-start',()=>{revealPaused=paused;paused=true;stop()});
  root.addEventListener('wg:transition-end',()=>{if(revealPaused!==null)paused=revealPaused;revealPaused=null;start()});
  document.addEventListener('visibilitychange',start);
  window.addEventListener('resize',paint);
  slides.forEach(slide=>slide.querySelectorAll('img').forEach(image=>image.addEventListener('load',paint,{once:true})));
  paint();start();
 };
 document.querySelectorAll('[data-repaired-carousel]').forEach(initialize);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-repaired-carousel]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wg-mobile-offers"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-wgmd]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='1';const button=section.querySelector('.wgmd__toggle');const panel=section.querySelector('.wgmd__details');button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!expanded));panel.hidden=expanded;section.querySelector('.wgmd__arrow').textContent=expanded?'＋':'−';});});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrong-guy-clean-hero"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-wg-hero]').forEach(s=>{const a=[...s.querySelectorAll('[data-wg-shirt]')];if(!a.length)return;let n=0;const p=()=>a.forEach((x,i)=>{let d=(i-n+a.length)%a.length,q=d===0?['39%',getComputedStyle(s).getPropertyValue('--as'),'1',5]:d===1?['67%',getComputedStyle(s).getPropertyValue('--ss'),'.78',3]:d===a.length-1?['12%',getComputedStyle(s).getPropertyValue('--ss'),'.78',3]:['-7%','.49','.42',2];x.style.left=q[0];x.style.transform='scale('+q[1]+')';x.style.opacity=q[2];x.style.zIndex=q[3]});const m=d=>{n=(n+d+a.length)%a.length;p()};s.querySelector('[data-wg-prev]').onclick=()=>m(-1);s.querySelector('[data-wg-next]').onclick=()=>m(1);p();let t=+s.dataset.i;if(t)setInterval(()=>m(1),t)});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrong-guy-closet-carousel"]) return;
  try {
    
document.addEventListener('click',function(event){
  var button=event.target.closest('.wgcloset__pause');
  if(!button)return;
  var tier=button.closest('.wgcloset__tier');
  var ring=tier&&tier.querySelector('.wgcloset__ring');
  if(!ring)return;
  var paused=ring.style.animationPlayState==='paused';
  ring.style.animationPlayState=paused?'running':'paused';
  button.setAttribute('aria-pressed',String(!paused));
  button.textContent=paused?'PAUSE':'RESUME';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrong-guy-collection-gateway"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.wgcg').forEach((root)=>{
  const section=root.closest('[id^="shopify-section"]');
  for(let sibling=section?.nextElementSibling;sibling;sibling=sibling.nextElementSibling){
    sibling.classList.add('wgcg-footer-skin');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrong-guy-mobile-master"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const initialize=(root)=>{
  if(root.dataset.orbitReady==='true')return;
  root.dataset.orbitReady='true';
  const slides=[...root.querySelectorAll('[data-slide]')];
  const dots=[...root.querySelectorAll('[data-go]')];
  const track=root.querySelector('.wgmm__track');
  const pauseButton=root.querySelector('.wgmm__pause');
  const designTitle=root.querySelector('[data-design-title]');
  if(slides.length<1||!track)return;
  const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  const total=slides.length;
  const step=Math.PI*2/total;
  const interval=Math.max(1000,Number(root.dataset.interval)||1000);
  const flagshipIndex=slides.findIndex(slide=>(slide.dataset.designName||'').toUpperCase().includes('KINDNESS'));
  let angle=Math.max(0,flagshipIndex)*step,paused=reduced,focusWithin=false,hovering=false;
  let announced=-1,revealPaused=null;
  const setting=(name,fallback)=>{
   const value=parseFloat(getComputedStyle(root).getPropertyValue(name));
   return Number.isFinite(value)?value:fallback;
  };
  const normalize=value=>((value+Math.PI)%(Math.PI*2)+Math.PI*2)%(Math.PI*2)-Math.PI;
  const renderTitle=(element,index)=>{
   const rawDesign=slides[index].dataset.designName||'';
   const hasTrademark=rawDesign.includes('™');
   const lines=rawDesign.replaceAll('™','').split('|').filter(Boolean);
   const twoLine=lines.join(' ').toUpperCase().trim()==='UNDERESTIMATE WITH CAUTION';
   element.classList.toggle('wgmm__design-name--two-line',twoLine);
   const spans=lines.map((line,lineIndex)=>{
    const span=document.createElement('span');
    span.textContent=(twoLine&&lineIndex===0?'“':'')+line.trim()+(twoLine&&lineIndex===lines.length-1?'”':'');
    return span;
   });
   element.replaceChildren(...(twoLine?spans:[document.createTextNode('“'),...spans,document.createTextNode('”')]),...(hasTrademark?[document.createTextNode('™')]:[]));
  };
  let titleLayoutKey='';
  const reserveTitleSpace=()=>{
   if(!designTitle||!designTitle.parentElement||!designTitle.clientWidth)return;
   const style=getComputedStyle(designTitle);
   const key=[designTitle.clientWidth,style.fontFamily,style.fontSize,style.fontWeight,style.fontStyle,style.lineHeight,style.letterSpacing].join('|');
   if(key===titleLayoutKey)return;
   const probe=designTitle.cloneNode(false);
   probe.removeAttribute('id');
   probe.removeAttribute('data-design-title');
   probe.setAttribute('aria-hidden','true');
   Object.assign(probe.style,{position:'absolute',inset:'0 auto auto 0',width:designTitle.clientWidth+'px',height:'auto',minHeight:'0',maxHeight:'none',visibility:'hidden',pointerEvents:'none',transform:'none',transition:'none'});
   designTitle.parentElement.append(probe);
   let height=0;
   slides.forEach((slide,index)=>{renderTitle(probe,index);height=Math.max(height,probe.offsetHeight)});
   probe.remove();
   designTitle.style.minHeight=Math.ceil(height)+'px';
   titleLayoutKey=key;
  };
  const paint=()=>{
   if(!root.isConnected)return;
   reserveTitleSpace();
   const width=track.clientWidth||root.clientWidth;
   const height=track.clientHeight||root.clientHeight;
   const radiusX=(width<750?Math.min(width*.35,132):Math.min(width*.40,286))*.78;
   const centerY=height*.78-(width<750?12:32);
   const radiusY=width<750?height*.08:height*.14;
   const overall=setting('--model-scale',.82)*setting('--carousel-scale',1);
   const frontScale=setting('--active-scale',1.12);
   const rearScale=setting('--side-scale',.68);
   const frontAnchor=centerY+radiusY+height*.10;
   const tallest=Math.max(...slides.map(slide=>slide.offsetHeight));
   const fit=Math.min(1,Math.max(0,frontAnchor-16)/(tallest*overall*frontScale*1.1));
   const fittedOverall=overall*fit*.92;
   const poolY=frontAnchor-tallest*fittedOverall*frontScale*1.1*.055;
   const poolHeight=width<750?Math.min(70,Math.max(48,width*.10)):Math.min(116,Math.max(72,width*.09));
   const carousel=root.querySelector('.wgmm__carousel');
   carousel.style.setProperty('--pool-y',poolY.toFixed(2)+'px');
   // Preserve model scale and move the complete stage together.
   const imageBounds=[
    ['wg-kindness-clean-edges-v1.png',20/1099,1],
    ['wg-unequal_match-clean-edges-v1.png',21/1374,1],
    ['wg-erratically-transparent-no-haze-v3.png',58/1536,1425/1536],
    ['wg-assume-transparent-no-haze-v3.png',48/1536,1],
    ['wg-twisted-carousel-final.png',65/1536,1422/1536],
    ['wrong-guy-carousel-blond-white-male-gold-v2.png',29/1536,1414/1536]
   ];
   const frontHeights=slides.map(slide=>{
    const image=slide.querySelector('img:last-child');
    const imageHeight=image&&image.naturalWidth?Math.min(slide.clientHeight,slide.clientWidth*image.naturalHeight/image.naturalWidth):slide.clientHeight;
    const fitScale=parseFloat(getComputedStyle(slide).getPropertyValue('--fit-scale'))||1;
    const bounds=imageBounds.find(entry=>image&&image.src.includes(entry[0]))||['',0,1];
    const bottomSpace=(matchMedia('(max-width:749px)').matches?0:slide.clientHeight-imageHeight)+imageHeight*(1-bounds[2]);
    slide.style.setProperty('--leg-offset',(bottomSpace*fitScale).toFixed(2)+'px');
    return imageHeight*(bounds[2]-bounds[1])*fitScale*fittedOverall*frontScale*1.1;
   });
   const maxFrontHeight=Math.max(...frontHeights);
   const lowerBanner=root.querySelector('.wgmm__ticker');const tagline=root.querySelector('.wg-header-master .wgmm__tagline-banner');if(tagline){const headerEnd=(tagline.getBoundingClientRect().bottom-root.getBoundingClientRect().top)+'px';root.style.setProperty('--wg-header-end',headerEnd);if(lowerBanner)lowerBanner.style.setProperty('top',headerEnd,'important');}
   const tickerText=lowerBanner?.querySelector('.wgmm__ticker-announcement');
   const tickerDivider=root.querySelector('.wg-ticker-divider');
   if(lowerBanner&&tickerText&&tickerDivider&&tagline){
    const tickerStyle=getComputedStyle(tickerText);
    const metricsKey=[lowerBanner.offsetTop,lowerBanner.offsetHeight,tickerStyle.font,document.fonts?.status].join('|');
    if(lowerBanner.dataset.ruleMetricsKey!==metricsKey){
     lowerBanner.style.setProperty('--ticker-copy-shift','0px');
     const textRect=tickerText.getBoundingClientRect();
     const rootTop=root.getBoundingClientRect().top;
     const context=document.createElement('canvas').getContext('2d');
     context.font=tickerStyle.font;
     const metrics=context.measureText(tickerText.textContent);
     const ascent=metrics.fontBoundingBoxAscent||metrics.actualBoundingBoxAscent;
     const descent=metrics.fontBoundingBoxDescent||metrics.actualBoundingBoxDescent;
     const baseline=textRect.top+(textRect.height-ascent-descent)/2+ascent;
     const glyphTop=baseline-metrics.actualBoundingBoxAscent-rootTop;
     const actualGlyphBottom=baseline+metrics.actualBoundingBoxDescent-rootTop;
    const tickerCenter=lowerBanner.getBoundingClientRect().top-rootTop+lowerBanner.offsetHeight/2;
    const glyphBottom=tickerCenter+(actualGlyphBottom-tickerCenter)/.88;
     const stripBottom=tagline.getBoundingClientRect().bottom-rootTop;
     const lowercaseMetrics=context.measureText('abcdefghijklmnopqrstuvwxyz');
     const lowercaseTop=baseline-lowercaseMetrics.actualBoundingBoxAscent-rootTop;
     const lowercaseBottom=baseline+lowercaseMetrics.actualBoundingBoxDescent-rootTop;
     const equalGap=Math.max(0,(glyphBottom-stripBottom-(lowercaseBottom-lowercaseTop))/2)*.9;
     let dividerY=stripBottom+(lowercaseBottom-lowercaseTop)+2*equalGap;
     const uppercaseMetrics=context.measureText('ABCDEFGHIJKLMNOPQRSTUVWXYZ');
     const opticalDrop=Math.max(0,uppercaseMetrics.actualBoundingBoxAscent-lowercaseMetrics.actualBoundingBoxAscent)/3;
     const centeredShift=stripBottom+equalGap-lowercaseTop+opticalDrop;
     dividerY-=Math.max(0,dividerY-(lowercaseBottom+centeredShift))*.1;
     root.style.setProperty('--ticker-divider-y',dividerY.toFixed(3)+'px');
     lowerBanner.style.setProperty('--ticker-copy-shift',centeredShift.toFixed(3)+'px');
     lowerBanner.dataset.ruleMetricsKey=metricsKey;
    }
   }
   const bannerBottom=parseFloat(root.style.getPropertyValue('--ticker-divider-y'))||(lowerBanner?lowerBanner.offsetTop+lowerBanner.offsetHeight:100);
   const frontBaseline=poolY+poolHeight*.63;
   const mobile=matchMedia('(max-width:749px)').matches;
   const about=root.querySelector('.wgmm__nav-about');
   const aboutRect=about?.getBoundingClientRect();
   const rootRect=root.getBoundingClientRect();
   const introduction=root.querySelector('.wg-statement__intro');
   const headTarget=bannerBottom+(mobile?112:45);
   const shift=headTarget-(carousel.offsetTop+frontBaseline-maxFrontHeight)-12;
   const floatingTitle=root.querySelector('[data-design-title]');
   const cartRectForGap=root.querySelector('.wgmm__cart')?.getBoundingClientRect();
   const navRectForGap=root.querySelector('.wgmm__nav')?.getBoundingClientRect();
   const navDescription=root.querySelector('.wg-statement__nav-description');
   if(navDescription&&navRectForGap){
    const contentWidth=navRectForGap.width/1.15;
    navDescription.style.left=((navRectForGap.width-contentWidth)/2).toFixed(2)+'px';
    navDescription.style.width=contentWidth.toFixed(2)+'px';
    const heading=navDescription.querySelector('.wg-statement__brand-heading');
    const subline=navDescription.querySelector('.wg-statement__brand-subline');
    navDescription.style.top=(bannerBottom+(40/3)+(parseFloat(getComputedStyle(heading).fontSize)*1.15/3)-(navRectForGap.top-rootRect.top)).toFixed(2)+'px';
    if(subline&&heading){
     subline.style.left='0';
     subline.style.width='100%';
     const preferred=parseFloat(getComputedStyle(heading).fontSize);
     subline.style.fontSize=preferred+'px';
     const naturalWidth=subline.scrollWidth;
     if(naturalWidth>contentWidth)subline.style.fontSize=(preferred*contentWidth/naturalWidth*.985).toFixed(3)+'px';
    }
   }
   const navBottomForGap=(navRectForGap?.top||rootRect.top)+Math.max(mobile?45:44,navRectForGap?.height||0)-rootRect.top;
   const referenceTitleHeight=floatingTitle?parseFloat(getComputedStyle(floatingTitle).fontSize)/.82*2.4:48;
   const titleTopForGap=navBottomForGap+Math.max(5,(headTarget-navBottomForGap-referenceTitleHeight)/2);
   const gapToTitle=mobile&&floatingTitle?Math.max(0,headTarget-titleTopForGap-referenceTitleHeight):0;
   const priorStageShift=shift-gapToTitle*.5;
   const priorHeadToBarsGap=Math.max(0,carousel.offsetTop+priorStageShift+frontBaseline-maxFrontHeight-bannerBottom);
   let raisedStageShift=priorStageShift-priorHeadToBarsGap/2;
   const brandSubline=navDescription?.querySelector('.wg-statement__brand-subline');
   if(brandSubline){
    const sentenceBottom=brandSubline.getBoundingClientRect().bottom-rootRect.top;
    const highestHead=carousel.offsetTop+raisedStageShift+frontBaseline-maxFrontHeight*(mobile?1.08:1);
    raisedStageShift+=Math.max(0,sentenceBottom+24-highestHead);
    const adjustedHead=carousel.offsetTop+raisedStageShift+frontBaseline-maxFrontHeight*(mobile?1.08:1);
    raisedStageShift-=Math.max(0,adjustedHead-sentenceBottom)/3;
    const currentHeadGap=Math.max(0,carousel.offsetTop+raisedStageShift+frontBaseline-maxFrontHeight*(mobile?1.08:1)-sentenceBottom);
    raisedStageShift-=currentHeadGap*.19;
   }
   if(introduction)introduction.style.translate='0 26px';
   carousel.style.setProperty('--stage-shift',raisedStageShift.toFixed(2)+'px');
   const cartHeadTop=carousel.offsetTop+raisedStageShift+frontBaseline-maxFrontHeight*(mobile?1.08:1);
   root.style.setProperty('--cart-head-y',Math.max(0,cartHeadTop).toFixed(3)+'px');
   const cartControl=root.querySelector('.wgmm__cart');
   const cartIcon=cartControl?.querySelector('svg');
   const cartLabel=cartControl?.querySelector('.wgmm__cart-label');
   if(cartIcon&&cartLabel){
    cartIcon.style.translate='0px 0px';cartIcon.style.scale='1';
    const iconRect=cartIcon.getBoundingClientRect();
    const labelRect=cartLabel.getBoundingClientRect();
    const centerShift=labelRect.left+labelRect.width/2-iconRect.left-iconRect.width/2;
    cartIcon.style.translate=centerShift.toFixed(3)+'px 0px';
    cartIcon.style.scale='1.44';
    const rightEdgeGap=Math.max(0,document.documentElement.clientWidth-cartIcon.getBoundingClientRect().right);
    cartIcon.style.translate=(centerShift+rightEdgeGap/3).toFixed(3)+'px 0px';
    cartLabel.setAttribute('aria-hidden','true');
   }
   const renderedPoolHeight=parseFloat(getComputedStyle(carousel,'::after').height)||poolHeight;
   const announcement=root.querySelector('[data-design-announcement]');
   const captionY=carousel.offsetTop+raisedStageShift+poolY+renderedPoolHeight+24;
   root.style.removeProperty('--floating-title-shift');
   root.style.removeProperty('--action-in-nav');
   root.style.setProperty('--caption-y',captionY.toFixed(2)+'px');
   const assortment=root.querySelector('.wgmm__lower-copy .wg-assortment-featured');
   const musicFrame=root.querySelector('.wgmm__lower-copy>.wg-page-music');
   if(assortment&&musicFrame){
    assortment.style.fontSize='18.75px';
    assortment.style.whiteSpace='nowrap';
    assortment.style.width='max-content';
    assortment.style.maxWidth='none';
    assortment.style.marginInline='auto';
    const textRange=document.createRange();
    textRange.selectNodeContents(assortment);
    const baseWidth=textRange.getBoundingClientRect().width;
    const frameWidth=musicFrame.getBoundingClientRect().width;
    if(baseWidth>0&&frameWidth>baseWidth){
     const targetWidth=(baseWidth+frameWidth)/2;
     assortment.style.fontSize=(18.75*targetWidth/baseWidth).toFixed(4)+'px';
    }
    assortment.style.fontSize=(parseFloat(assortment.style.fontSize)*1.08).toFixed(4)+'px';
   }
   const apparelDescription=assortment?.closest('.wg-statement__mobile-description');
   const apparelDivider=root.querySelector('.wgmm__lower-copy>.wg-assortment-divider');
   if(apparelDescription&&apparelDivider&&assortment){
    apparelDivider.style.marginTop='4px';
    const apparelRange=document.createRange();
    apparelRange.selectNodeContents(assortment);
    const apparelRect=apparelRange.getBoundingClientRect();
    const originalGap=Math.max(0,apparelDivider.getBoundingClientRect().top-apparelRect.bottom);
    const reducedGap=originalGap*.8;
    apparelDivider.style.marginTop=(4-originalGap*.2).toFixed(5)+'px';
    const upperLineY=apparelRect.top-apparelDescription.getBoundingClientRect().top-reducedGap-1;
    apparelDescription.style.setProperty('--wg-apparel-upper-line-y',upperLineY.toFixed(5)+'px');
    apparelDescription.style.setProperty('--wg-apparel-line-visibility','visible');
   }
   const spacingButton=announcement?.querySelector('.wg-top-door');
   const spacingNote=announcement?.querySelector('.wgmm__scale-note');
   const spacingTitle=announcement?.querySelector('.wgmm__design-name');
   const spacingLower=announcement?.querySelector('.wgmm__lower-copy');
   if(spacingButton&&spacingNote&&spacingTitle&&spacingLower&&apparelDescription){
    spacingButton.style.setProperty('margin-top','0px','important');
    spacingLower.style.setProperty('margin-top','-9.6991888px','important');
    apparelDescription.style.marginTop='0px';
    const textBounds=element=>{
     const range=document.createRange();
     range.selectNodeContents(element);
     return range.getBoundingClientRect();
    };
    const noteText=spacingNote.querySelector('.wgmm__scale-note-first')||spacingNote;
    const noteBounds=()=>{
     const range=document.createRange();
     const node=noteText.firstChild;
     if(node&&node.nodeType===Node.TEXT_NODE){range.selectNodeContents(node);}
     else{range.selectNodeContents(noteText);}
     return range.getBoundingClientRect();
    };
    const poolBottom=carousel.getBoundingClientRect().top+poolY+renderedPoolHeight;
    const titleGap=Math.max(0,textBounds(spacingTitle).top-poolBottom);
    root.style.setProperty('--caption-y',(captionY-titleGap*.08).toFixed(5)+'px');
    const buttonGap=Math.max(0,spacingButton.getBoundingClientRect().top-textBounds(spacingTitle).bottom);
    const buttonZoom=parseFloat(getComputedStyle(spacingButton).zoom)||1;
    spacingButton.style.setProperty('margin-top',(-buttonGap*.1/buttonZoom).toFixed(5)+'px','important');
    const noteGap=Math.max(0,noteBounds().top-spacingButton.getBoundingClientRect().bottom);
    spacingLower.style.setProperty('margin-top',(-9.6991888-noteGap*.2).toFixed(5)+'px','important');
    const upperRuleTop=apparelDescription.getBoundingClientRect().top+(parseFloat(getComputedStyle(apparelDescription,'::before').top)||0);
    const ruleGap=Math.max(0,upperRuleTop-noteBounds().bottom);
    apparelDescription.style.marginTop=(ruleGap*.18).toFixed(5)+'px';
   }
   const musicControls=musicFrame?.querySelector('.wg-music-controls');
   const firstMusicButton=musicControls?.querySelector('button');
   if(musicFrame&&musicControls&&firstMusicButton){
    musicControls.style.paddingTop='0px';
    const frameRect=musicFrame.getBoundingClientRect();
    const innerBorderStyle=getComputedStyle(musicFrame,'::before');
    const innerBorderBottom=frameRect.top+(parseFloat(innerBorderStyle.top)||3)+(parseFloat(innerBorderStyle.borderTopWidth)||1);
    const currentButtonGap=Math.max(0,firstMusicButton.getBoundingClientRect().top-innerBorderBottom);
    musicControls.style.paddingTop=currentButtonGap.toFixed(3)+'px';
   }
   const volumeInput=musicFrame?.querySelector('[data-wg-volume]');
   if(musicFrame&&volumeInput){
    musicFrame.style.setProperty('padding-bottom','10px','important');
    const frameBottom=musicFrame.getBoundingClientRect().bottom-4;
    const sliderBottom=volumeInput.getBoundingClientRect().bottom;
    const lowerGap=Math.max(0,frameBottom-sliderBottom);
    musicFrame.style.setProperty('padding-bottom',Math.max(0,10-lowerGap*.1).toFixed(3)+'px','important');
   }
   const giftTitle=root.querySelector('.wg-gift-message__title');
   const giftEyebrow=root.querySelector('.wg-gift-message__eyebrow');
   const offer=root.querySelector('.wg-gift-message__offer');
   if(giftEyebrow&&offer){
    giftEyebrow.style.transform='none';
    const range=document.createRange();
    range.selectNodeContents(giftEyebrow);
    const baseWidth=range.getBoundingClientRect().width;
    const ruleWidth=musicFrame?Math.max(0,musicFrame.getBoundingClientRect().width-8):document.documentElement.clientWidth*.9;
    const widthScale=baseWidth>0?ruleWidth/baseWidth/1.05:1;
    giftEyebrow.style.transform='scale('+(widthScale*1.05).toFixed(4)+',1.26)';
   }
   if(giftTitle&&offer){
    giftTitle.style.transform='none';
    const questionRange=document.createRange();
    questionRange.selectNodeContents(giftTitle);
    const naturalQuestionWidth=questionRange.getBoundingClientRect().width;
    const resizedHeadingWidth=giftEyebrow?giftEyebrow.getBoundingClientRect().width:offer.getBoundingClientRect().width;
    const matchingRuleWidth=resizedHeadingWidth*.85;
    if(naturalQuestionWidth>0&&matchingRuleWidth>0){
     const headingBottom=giftEyebrow?.getBoundingClientRect().bottom||giftTitle.getBoundingClientRect().top;
     const questionGap=Math.max(0,giftTitle.getBoundingClientRect().top-headingBottom);
     giftTitle.style.transform='translateY('+(-questionGap*.15).toFixed(3)+'px) scaleX('+(matchingRuleWidth/naturalQuestionWidth).toFixed(5)+')';
    }
   }
   if(offer&&giftTitle){
    offer.style.paddingBottom='0px';
    const textRange=document.createRange();textRange.selectNodeContents(offer);
    const offerText=textRange.getBoundingClientRect();
    const questionText=document.createRange();questionText.selectNodeContents(giftTitle);
    const referenceGap=Math.max(0,offerText.top-questionText.getBoundingClientRect().bottom);
    const trailing=offer.getBoundingClientRect().bottom-offerText.bottom;
    offer.style.paddingBottom=Math.max(0,referenceGap*1.1+1-trailing).toFixed(3)+'px';
   }
   const contentEnd=Math.max(offer?.getBoundingClientRect().bottom||0,musicFrame?.getBoundingClientRect().bottom||0);
   const contentHeight=contentEnd?Math.max(captionY,contentEnd-root.getBoundingClientRect().top+16):captionY+(announcement?.offsetHeight||200)+24;
   root.style.height=contentHeight.toFixed(2)+'px';
   root.style.minHeight=contentHeight.toFixed(2)+'px';
   if(mobile){root.style.setProperty('--mobile-content-height',contentHeight.toFixed(2)+'px');carousel.style.setProperty('--arrow-y',(poolY+poolHeight*.35).toFixed(2)+'px');}
   const supportFooter=document.querySelector('.wg-support-footer');
   if(offer&&supportFooter){
    supportFooter.style.setProperty('padding-top','0px','important');
    const nav=supportFooter.querySelector('nav');
    const credits=supportFooter.querySelector('.wg-music-credits');
    const glyphRect=element=>{const range=document.createRange();range.selectNodeContents(element);return range.getBoundingClientRect()};
    const links=nav?[...nav.querySelectorAll('a')]:[];
    if(nav&&credits&&links.length>=6){
     links.forEach(link=>link.style.translate='none');nav.style.marginBottom='0px';
     const firstBottom=Math.max(...links.slice(0,3).map(link=>glyphRect(link).bottom));
     const secondTop=Math.min(...links.slice(3,6).map(link=>glyphRect(link).top));
     const lift=Math.max(0,secondTop-firstBottom)*.5;
     links.slice(3,6).forEach(link=>link.style.translate='0 '+(-lift).toFixed(3)+'px');
     nav.style.marginBottom=(-lift).toFixed(3)+'px';
     credits.style.marginTop='12px';
     const underlineBottom=Math.max(...links.map(link=>glyphRect(link).bottom+(parseFloat(getComputedStyle(link).textUnderlineOffset)||4)+1));
     const oldGap=Math.max(0,credits.getBoundingClientRect().top-underlineBottom);
     credits.style.marginTop=(12-oldGap*.1).toFixed(3)+'px';
     const clearance=Math.max(0,credits.getBoundingClientRect().top-underlineBottom);
     const firstTop=Math.min(...links.slice(0,3).map(link=>glyphRect(link).top));
     const offerEnd=contentEnd;
     const footerTop=supportFooter.getBoundingClientRect().top;
     const desiredShift=offerEnd+clearance-firstTop;
     const correction=Math.max(desiredShift,offerEnd-footerTop);
     const oldMargin=parseFloat(getComputedStyle(supportFooter).marginTop)||0;
     if(Math.abs(correction)>.25)supportFooter.style.marginTop=(oldMargin+correction).toFixed(3)+'px';
    }
   }
   let nearest=0,nearestDistance=Infinity,nearestFrontEase=0;
   slides.forEach((slide,index)=>{
    const theta=normalize(index*step-angle);
    const cosine=Math.cos(theta);
    const depth=(cosine+1)/2;
    const scale=rearScale+(frontScale-rearScale)*Math.pow(depth,1.8);
    const x=Math.sin(theta)*radiusX;
    const y=poolY+poolHeight*(.45+.18*cosine);
    const front=Math.abs(theta)<step/2;
    const frontDistance=Math.max(0,1-Math.abs(theta)/(step/2));
    const frontEase=frontDistance*frontDistance*(3-2*frontDistance);
    if(Math.abs(theta)<nearestDistance){nearest=index;nearestDistance=Math.abs(theta);nearestFrontEase=frontEase}
    const baseModelScale=fittedOverall*scale*(1+.1*frontEase);
    const modelZoom=mobile?1.08:1;
    const addedHeight=slide.offsetHeight*baseModelScale*(modelZoom-1);
    // Let the head rise modestly; never use more than one third of the remaining title gap.
    const headRise=mobile?Math.min(addedHeight*.6,gapToTitle/6):0;
    const headAnchorOffset=addedHeight/2-headRise;
    slide.style.left='calc(50% + '+x.toFixed(2)+'px)';
    slide.style.top=(y+headAnchorOffset).toFixed(2)+'px';
    slide.style.transform='translate(-50%,-100%) scale('+(baseModelScale*modelZoom).toFixed(3)+')';
    slide.style.opacity=(.56+depth*.44).toFixed(2);
    slide.style.zIndex=String(Math.round(1+depth*1000));
    slide.classList.toggle('is-front',front);
    slide.setAttribute('aria-current',String(front));slide.setAttribute('aria-label',(front?'Selected: ':'Bring to the front: ')+(slide.dataset.designName||'shirt').replaceAll('|',' '));
    slide.tabIndex=front?0:-1;
   });
   dots.forEach((dot,index)=>dot.setAttribute('aria-pressed',String(index===nearest)));
   if(designTitle){designTitle.style.opacity=nearestFrontEase.toFixed(2);designTitle.style.transform='none';}
   if(designTitle&&announced!==nearest){
    announced=nearest;
    renderTitle(designTitle,nearest);
   }
  };
  if(total===1){
   root.querySelectorAll('.wgmm__arrow').forEach(button=>{button.disabled=true;button.hidden=true});
   if(pauseButton)pauseButton.hidden=true;
   window.addEventListener('resize',paint);
   slides[0].querySelectorAll('img').forEach(image=>image.addEventListener('load',paint,{once:true}));
   paint();
   return;
  }
  let timer=null;
  const turnDuration=3000;
  let frame=null,turnStart=0,fromAngle=0,toAngle=0;
  const stop=()=>{
   if(timer!==null)clearTimeout(timer);
   if(frame!==null)cancelAnimationFrame(frame);
   timer=null;frame=null;turnStart=0;
  };
  const animateTurn=now=>{
   if(!root.isConnected||paused||focusWithin||hovering||document.hidden){frame=null;turnStart=0;return}
   if(!turnStart)turnStart=now;
   const progress=Math.min(1,(now-turnStart)/turnDuration);
   const eased=progress<.5?4*progress*progress*progress:1-Math.pow(-2*progress+2,3)/2;
   angle=fromAngle+(toAngle-fromAngle)*eased;
   paint();
   if(progress<1){frame=requestAnimationFrame(animateTurn);return}
   angle=toAngle;paint();frame=null;turnStart=0;
   timer=window.setTimeout(advance,interval);
  };
  const advance=()=>{
   if(!root.isConnected||paused||focusWithin||hovering||document.hidden)return;
   fromAngle=angle;toAngle=(Math.floor(angle/step+1e-7)+1)*step;turnStart=0;
   frame=requestAnimationFrame(animateTurn);
  };
  const start=()=>{stop();if(root.isConnected&&!paused&&!focusWithin&&!hovering&&!document.hidden)timer=window.setTimeout(advance,interval)};
  const goTo=index=>{angle=index*step;paint();start()};
  const manual=direction=>{angle=(Math.round(angle/step)+direction)*step;paint();start()};
  const updatePauseButton=()=>{
   if(!pauseButton)return;
   pauseButton.textContent=paused?pauseButton.dataset.resume:pauseButton.dataset.pause;
   pauseButton.setAttribute('aria-label',paused?'Resume automatic rotation':'Pause automatic rotation');
   pauseButton.setAttribute('aria-pressed',String(paused));root.toggleAttribute('data-motion-paused',paused);
  };
  if(pauseButton){
   updatePauseButton();
   pauseButton.addEventListener('click',()=>{
    paused=!paused;
    updatePauseButton();
    if(paused)stop();
    else{focusWithin=false;start()}
   });
  }

  root.querySelector('.wgmm__arrow--prev').addEventListener('click',()=>manual(-1));
  root.querySelector('.wgmm__arrow--next').addEventListener('click',()=>manual(1));
  dots.forEach((dot,index)=>dot.addEventListener('click',()=>goTo(index)));
  let focusOverlay=null,focusSource=null,pausedBeforeFocus=false;
  const closeFocus=()=>{
   if(!focusOverlay)return;
   const overlay=focusOverlay,source=focusSource,resumePaused=pausedBeforeFocus;
   focusOverlay=null;
   overlay.classList.remove('is-open');
   window.setTimeout(()=>{
    overlay.close();overlay.remove();
    source?.removeAttribute('aria-expanded');
    if(document.activeElement===source)source.blur();
    focusSource=null;focusWithin=false;paused=resumePaused;updatePauseButton();start();
   },matchMedia('(prefers-reduced-motion:reduce)').matches?0:920);
  };
  const openFocus=slide=>{
   const image=slide.querySelector('img:last-child');
   if(!image)return;
   pausedBeforeFocus=paused;paused=true;updatePauseButton();stop();
   const overlay=document.createElement('dialog');
   overlay.className='wgmm__focus-overlay';
   overlay.setAttribute('aria-label','Enlarged '+(slide.dataset.designName||'model').replaceAll('|',' '));
   const model=document.createElement('button');
   model.type='button';model.className='wgmm__focus-model';
   model.setAttribute('aria-label','Return model to carousel');
   const enlarged=image.cloneNode(true);
   enlarged.removeAttribute('loading');enlarged.removeAttribute('fetchpriority');
   model.append(enlarged);overlay.append(model);document.body.append(overlay);
   focusOverlay=overlay;focusSource=slide;slide.setAttribute('aria-expanded','true');
   model.addEventListener('click',closeFocus);
   overlay.addEventListener('click',event=>{if(event.target===overlay)closeFocus()});
   overlay.addEventListener('cancel',event=>{event.preventDefault();closeFocus()});
   overlay.showModal();model.focus({preventScroll:true});
   requestAnimationFrame(()=>overlay.classList.add('is-open'));
  };
  slides.forEach((slide,index)=>slide.addEventListener('click',()=>{
   if(slide.classList.contains('is-front')){
    angle=index*step;paint();openFocus(slide);return;
   }
   goTo(index);
  }));
  root.addEventListener('keydown',event=>{if(event.target.closest('a'))return;if(event.key==='ArrowRight'){event.preventDefault();manual(1)}if(event.key==='ArrowLeft'){event.preventDefault();manual(-1)}});
  let touchX=null,touchY=null;
  track.addEventListener('touchstart',event=>{touchX=event.changedTouches[0].clientX;touchY=event.changedTouches[0].clientY},{passive:true});
  track.addEventListener('touchend',event=>{if(touchX===null)return;const dx=event.changedTouches[0].clientX-touchX,dy=event.changedTouches[0].clientY-touchY;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.25)manual(dx<0?1:-1);touchX=null},{passive:true});
  root.addEventListener('focusin',event=>{if(event.target.closest('.wgmm__pause'))return;focusWithin=event.target.matches(':focus-visible');if(focusWithin)stop();else start()});
  root.addEventListener('focusout',()=>{window.setTimeout(()=>{const active=document.activeElement;focusWithin=root.contains(active)&&Boolean(active?.matches(':focus-visible'))&&!(active&&active.closest('.wgmm__pause'));start()},0)});
  root.addEventListener('mouseenter',()=>{hovering=false});
  root.addEventListener('mouseleave',()=>{hovering=false;start()});
  root.addEventListener('wg:transition-start',()=>{revealPaused=paused;paused=true;stop()});
  root.addEventListener('wg:transition-end',()=>{if(revealPaused!==null)paused=revealPaused;revealPaused=null;start()});
  document.addEventListener('visibilitychange',start);
  window.addEventListener('resize',paint);
  slides.forEach(slide=>slide.querySelectorAll('img').forEach(image=>image.addEventListener('load',paint,{once:true})));
  if(document.fonts)document.fonts.ready.then(()=>{titleLayoutKey='';paint()});
  paint();start();
 };
 document.querySelectorAll('[data-repaired-carousel]').forEach(initialize);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-repaired-carousel]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrong-guy-rotating-hero"] && !Shopify.designMode) return;
  try {
    
const carousels = document.querySelectorAll('[data-wg-carousel]');
document.querySelectorAll('header:not(.wg-hero__header), .announcement-bar, .utility-bar').forEach((element) => { element.style.display = 'none'; });
carousels.forEach((carousel) => {
  const slides = Array.from(carousel.querySelectorAll('[data-slide]'));
  if (!slides.length) return;
  let active = 0;
  let touchStart = 0;
  const paint = () => {
    slides.forEach((slide, index) => {
      let distance = index - active;
      if (distance > slides.length / 2) distance -= slides.length;
      if (distance < -slides.length / 2) distance += slides.length;
      const abs = Math.abs(distance);
      slide.style.setProperty('--x', `${distance * 52}%`);
      slide.style.setProperty('--scale', abs === 0 ? '1' : abs === 1 ? '.7' : '.48');
      slide.style.setProperty('--opacity', abs > 2 ? '0' : abs === 0 ? '1' : abs === 1 ? '.72' : '.18');
      slide.classList.toggle('is-active', abs === 0);
      slide.tabIndex = abs === 0 ? 0 : -1;
    });
  };
  const move = (step) => { active = (active + step + slides.length) % slides.length; paint(); };
  carousel.querySelector('.wg-hero__arrow--prev').addEventListener('click', () => move(-1));
  carousel.querySelector('.wg-hero__arrow--next').addEventListener('click', () => move(1));
  carousel.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].screenX; }, { passive: true });
  carousel.addEventListener('touchend', (event) => { const distance = event.changedTouches[0].screenX - touchStart; if (Math.abs(distance) > 30) move(distance > 0 ? -1 : 1); }, { passive: true });
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) setInterval(() => move(1), 4200);
  paint();
});

  } catch(e) { console.error(e); }
})();
})();
